module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACHRSTlMA5h5JGcO1xADr9AcAAABGSURBVBjTY8APIjo6WqFMwwYgp51DGMyRaAGRHo1gTkebAwMDS0YHhAMBpHGaGBg0iFMGVEi5aZgcCQi7EeJTCEcYX8AAAOZwRZsx8nbrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_order_active.png
// module id = FvMx
// module chunks = 9